export default __webpack_public_path__ + "static/media/Ballroll_00067.4202008a.png";